import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TrafficLightColor } from 'src/app/analysis/models/criterions/TrafficLightColor';

@Component({
    selector: 'sera-popup',
    templateUrl: './sera-popup.component.html',
    styleUrls: ['./sera-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraPopupComponent {
    @Input()
    display: boolean = false;
    @Input()
    internalFooterBar: boolean = false;

    @Input()
    headerText: string = '';

    @Input()
    popupClass: string = '';

    @Input()
    minWidth: string = '576px';

    @Input()
    minHeight: string = '68px';

    @Input()
    allowOverflow: boolean = false;

    @Input()
    headerIcon?: string;

    @Input()
    dsHeaderIcon?: string;

    @Input()
    draggable: boolean = false;

    @Input()
    closeOnEscape: boolean = true;

    @Input()
    closableWithX: boolean = true;

    @Input()
    showLimitExceeded: boolean = false;

    @Input()
    showRIComponent: boolean = false;

    @Input()
    rzValue?: number | null;

    @Input()
    color?: TrafficLightColor | null;

    @Output()
    displayChange = new EventEmitter<boolean>();

    @Output()
    popupOpened = new EventEmitter<any>();

    @Output()
    popupHidden = new EventEmitter<any>();

    onShow() {
        this.displayChange.emit(this.display);
        this.popupOpened.emit();
    }
    onHide() {
        this.displayChange.emit(this.display);
        this.popupHidden.emit();
    }

    protected readonly TrafficLightColor = TrafficLightColor;
}
